export default "__VITE_ASSET__BVrFrnKT__"